/* src/app/shared/process/process-detail/process-detail.component.scss */
a {
  text-decoration: none;
}
/*# sourceMappingURL=process-detail.component.css.map */
